module.exports = __webpack_public_path__ + "img/EXTERIOR-IGNIS-1.33fe9311.jpg";